import React from 'react';

export const Help = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) => {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon / Help">
          <path
            id="Icon"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 0.799988C11.187 0.799988 0.800049 11.187 0.800049 24C0.800049 36.813 11.187 47.2 24 47.2C36.8131 47.2 47.2001 36.813 47.2001 24C47.2001 11.187 36.8131 0.799988 24 0.799988ZM41.336 17.8186C42.0249 19.7505 42.4 21.8314 42.4 24C42.4 26.1685 42.0249 28.2494 41.336 30.1814L33.8161 27.4444C34.1944 26.3664 34.4 25.2072 34.4 24C34.4 22.7928 34.1944 21.6336 33.8161 20.5556L41.336 17.8186ZM39.5772 14.202C36.3195 9.03368 30.5608 5.59999 24 5.59999C17.4393 5.59999 11.6806 9.03368 8.42288 14.202L16.2593 17.0542C18.1633 14.9338 20.9259 13.6 24 13.6C27.0742 13.6 29.8368 14.9338 31.7408 17.0542L39.5772 14.202ZM31.7408 30.9457L39.5772 33.798C36.3195 38.9663 30.5608 42.4 24 42.4C17.4393 42.4 11.6806 38.9663 8.42288 33.798L16.2593 30.9457C18.1633 33.0662 20.9259 34.4 24 34.4C27.0742 34.4 29.8368 33.0662 31.7408 30.9457ZM6.66411 17.8186C5.97519 19.7505 5.60005 21.8314 5.60005 24C5.60005 26.1685 5.97519 28.2494 6.66411 30.1814L14.184 27.4444C13.8057 26.3664 13.6 25.2072 13.6 24C13.6 22.7928 13.8057 21.6336 14.184 20.5556L6.66411 17.8186ZM24 18.4C27.0928 18.4 29.6 20.9072 29.6 24C29.6 27.0928 27.0928 29.6 24 29.6C20.9073 29.6 18.4 27.0928 18.4 24C18.4 20.9072 20.9073 18.4 24 18.4Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  );
};
